import { Component, Input, OnInit } from '@angular/core'
import { PropertySearcher } from '../../helpers/property-searcher.helper';
import { ComponentConfiguration } from '../../models/component-config.model';
import { OrderCargoDetailsViewComponent } from '../order-cargo-details-view/order-cargo-details-view.component';
import { OrderClientDetailsViewComponent } from '../order-client-details-view/order-client-details-view.component';
import { OrderPriceDetailsViewComponent } from '../order-price-details-view/order-price-details-view.component';

@Component({
  selector: 'app-order-details-row-view',
  templateUrl: './order-details-row-view.component.html',
  styleUrls: ['./order-details-row-view.component.scss'],
})
export class OrderDetailsRowViewComponent implements OnInit {
  @Input() data: unknown;

  selectRowClick: ((...args: unknown[]) => unknown) | undefined;
  originConfig: ComponentConfiguration = { componentType: OrderClientDetailsViewComponent, withParseData: true  };
  destinationConfig: ComponentConfiguration = { componentType: OrderClientDetailsViewComponent, withParseData: true  };
  cargoConfig: ComponentConfiguration = { componentType: OrderCargoDetailsViewComponent, withParseData: true  };
  clientConfig: ComponentConfiguration = { componentType: OrderClientDetailsViewComponent, withParseData: true  };
  priceDetailsConfig: ComponentConfiguration = { componentType: OrderPriceDetailsViewComponent, withParseData: true  };

  ngOnInit() {
    this.selectRowClick = PropertySearcher.findValue(this.data, 'selectRowClick');
    this.originConfig.actualData = PropertySearcher.findValue(this.data, 'origin');
    this.destinationConfig.actualData = PropertySearcher.findValue(this.data, 'destination');
    this.cargoConfig.actualData = PropertySearcher.findValue(this.data, 'cargo');
    this.clientConfig.actualData = PropertySearcher.findValue(this.data, 'client');
    this.priceDetailsConfig.actualData = PropertySearcher.findValue(this.data, 'orderDetails');
  }
}
